import { defineComponent } from "vue";

/**
 * 渲染 `Setting` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Setting = defineComponent({
	name: "Setting",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M916.7 424h-99.6c-6.6-23-15.8-45-27.2-65.5l70.4-70.4c16.1-16.1 16.1-42.3 0-58.4l-66.1-66.1c-16.1-16.1-42.3-16.1-58.4 0L665.5 234C645 222.7 623 213.5 600 206.9v-99.6c0-22.7-18.6-41.3-41.3-41.3h-93.4c-22.7 0-41.3 18.6-41.3 41.3v99.6c-23 6.6-45 15.8-65.5 27.2L288 163.6c-16.1-16.1-42.3-16.1-58.4 0l-66.1 66.1c-16.1 16.1-16.1 42.3 0 58.4l70.4 70.4c-11.2 20.5-20.4 42.5-27 65.5h-99.6C84.6 424 66 442.6 66 465.3v93.4c0 22.7 18.6 41.3 41.3 41.3h99.6c6.6 23 15.8 45 27.2 65.5L163.6 736c-16.1 16.1-16.1 42.3 0 58.4l66.1 66.1c16.1 16.1 42.3 16.1 58.4 0l70.4-70.4c20.6 11.4 42.5 20.5 65.5 27.2v99.6c0 22.7 18.6 41.3 41.3 41.3h93.4c22.7 0 41.3-18.6 41.3-41.3v-99.6c23-6.6 45-15.8 65.5-27.2l70.4 70.4c16.1 16.1 42.3 16.1 58.4 0l66.1-66.1c16.1-16.1 16.1-42.3 0-58.4L790 665.5c11.4-20.6 20.5-42.5 27.2-65.5h99.6c22.7 0 41.3-18.6 41.3-41.3v-93.4c-0.1-22.7-18.7-41.3-41.4-41.3zM512.1 650.6c-76.6 0.1-138.8-62.1-138.7-138.7 0.1-75.4 63.2-138.5 138.5-138.5 76.6-0.1 138.8 62.1 138.7 138.7 0 75.4-63.1 138.5-138.5 138.5z" />
			</svg>
		);
	},
});

export default Setting;
